export default __webpack_public_path__ + "static/media/case_1.6e3be515.svg";